import React, { useRef, useState } from 'react';
import { useEffect } from 'react';
import { FlatList, StyleSheet, Text, TouchableOpacity, Modal, View, ScrollView, Dimensions, Image, VirtualizedList } from 'react-native';
import { ThemeColours } from '../Styles/Theme';


const Dropdown = ({ label, data, onSelect, initialValue }) => {
  const DropdownButton = useRef();
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState(undefined);
  const [dropdownTop, setDropdownTop] = useState(0);

  const toggleDropdown = () => {
    visible ? setVisible(false) : openDropdown();
  };

  useEffect(() => {
    // Set the initial value, so long as it's an object with an id
    if (initialValue?.id) {
        setSelected(initialValue);
    }
  }, [])

  const openDropdown = () => {
    DropdownButton.current.measure((_fx, _fy, _w, h, _px, py) => {
      setDropdownTop(py + h);
    });
    setVisible(true);
  };

  const onItemPress = (item) => {
    setSelected(item);
    onSelect(item);
    setVisible(false);
  };

  const renderItem = ({ item }) => (
    <TouchableOpacity style={styles.item} onPress={() => onItemPress(item)}>
      <Text style={{fontSize: 18}}>{item.name}</Text>
    </TouchableOpacity>
  );

  return (
    <TouchableOpacity
      ref={DropdownButton}
      style={styles.button}
      onPress={toggleDropdown}
    >
      <Modal 
        visible={visible} 
        transparent={true}
        animationType="none"
        >
        <TouchableOpacity
          style={styles.overlay}
          onPress={() => setVisible(false)}
        >
          <View style={[styles.dropdown, { top: dropdownTop }]}>
            <FlatList
              data={data}
              renderItem={renderItem}
              keyExtractor={(item, index) => index.toString()}
            />
          </View>
        </TouchableOpacity>
      </Modal>
      <Text style={styles.buttonText}>
        {(!!selected && selected.name) || initialValue?.name || label}
      </Text>
      <Image source={require('../assets/images/dropDownIcon-2x.png')} style={{width: 16, height: 8}} />
    </TouchableOpacity>
  );
};

const {width} = Dimensions.get('screen');

const styles = StyleSheet.create({
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 50,
    zIndex: 1,
    paddingHorizontal: 10,
    backgroundColor: ThemeColours.white,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: ThemeColours.midnightBlue,
    borderRadius: 3
  },
  buttonText: {
    flex: 1,
    fontSize: 18,
  },
  icon: {
    marginRight: 10,
  },
  dropdown: {
    position: 'absolute',
    backgroundColor: ThemeColours.white,
    width: width - 60,
    marginHorizontal: 30,
    shadowColor: ThemeColours.midnightBlue,
    shadowRadius: 4,
    shadowOffset: { height: 4, width: 0 },
    shadowOpacity: 0.5,
  },
  overlay: {
    width: '100%',
    height: '100%',
    overflow: 'scroll',
  },
  item: {
    paddingHorizontal: 10,
    paddingVertical: 15,
    borderBottomWidth: 1,
  },
});

export default Dropdown;